import {
	AGRI_FRANCHISE_OPTIONS,
	BUSINESS_TYPE_OPTIONS,
	ExtensionStayEnum,
	ExtensionStayLabel,
	FISHERY_FRANCHISE_OPTIONS,
	ResidenceEnum,
	ResidenceLabel,
	VisaTimeEnum,
	VisaTimeLabel,
} from '@/constant';
import {
	GetWorkerProgramApplicantListResponse,
	GetWorkerProgramDetailResponse,
	GetWorkerProgramFranchiseListResponse,
	GetWorkerProgramListAllResponse,
	GetWorkerProgramListResponse,
} from '@/services';
import { convertReEntryRecommendationStatus, formatDate, map } from '@/utils';

import { DefaultOptionType } from 'antd/es/select';

import { isNotNilOrEmpty } from 'ramda-adjunct';

export const formatWorkerProgramDetail = (
	input: GetWorkerProgramDetailResponse
) => {
	return {
		...input,
		startDate: formatDate(input.startDate),
		endDate: formatDate(input.endDate),
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
	};
};

export const formatWorkerProgramListItem = (
	input: GetWorkerProgramListResponse['content'][number]
) => {
	return {
		...input,
		id: input?.programId,
		programStartDate: formatDate(input.programStartDate),
		programEndDate: formatDate(input.programEndDate),
		programRegistDt: formatDate(input.programRegistDt),
		programUpdateDt: formatDate(input.programUpdateDt),
	};
};

export const formatWorkerProgramList = (
	input: GetWorkerProgramListResponse['content']
) => {
	return map(input, formatWorkerProgramListItem);
};

export const formatWorkerProgramExcelList = (
	input: GetWorkerProgramListResponse['content']
) => {
	return map(input, (item) => {
		const thisKeys: (keyof typeof item)[] = [
			'programFarmCnt',
			'programAgriculturalCoCnt',
			'programPublicFranchiseCnt',
			'programFishingCnt',
			'programCorporateFishingCnt',
			'programFranchiseCnt',
		];

		const peopleCountKeys: (keyof typeof item)[] = [
			'programMouApplicantCnt',
			'programMarriageImmigrantsCnt',
			'programForeignersStayingCnt',
			'programReEntryCnt',
			'programApplicantCnt',
			'programWorkplaceChangeCnt',
			'programUnauthorizedDepartureCnt',
		];

		const formattedDataKeys = (data: (keyof typeof item)[], unit?: string) =>
			data.reduce(
				(acc, key) => {
					if (item[key] !== undefined) {
						acc[key] = isNotNilOrEmpty(item[key]) ? `${item[key]}${unit}` : '';
					}
					return acc;
				},
				{} as { [key: string]: string }
			);

		return {
			...formatWorkerProgramListItem(item),
			...formattedDataKeys(thisKeys, '개'),
			...formattedDataKeys(peopleCountKeys, '명'),
		};
	});
};

export const formatWorkerProgramApplicantDetail = (
	input: GetWorkerProgramApplicantListResponse['content'][number]
) => {
	return {
		...input,
		reentryRecommendationStatus: convertReEntryRecommendationStatus(
			input.reentryRecommendationStatus
		),
		birthDate: formatDate(input.birthDate),
		entryDate: formatDate(input.entryDate),
		extensionStayDate: formatDate(input.extensionStayDate),
		expirationDate: formatDate(input.expirationDate),
		departureDate: formatDate(input.departureDate),
		changeWorkDate: formatDate(input.changeWorkDate),
		unauthorizedDepartureDate: formatDate(input.unauthorizedDepartureDate),
		isReEntry: input.isReEntry ? 'O' : 'X',
		isPublic: input.isPublic ? 'O' : 'X',
		registDt: formatDate(input.registDt),
		extensionPeriod:
			ExtensionStayLabel[input.extensionPeriod as ExtensionStayEnum],
		visaCode: ResidenceLabel[input.visaCode as ResidenceEnum] || '',
		visaTime: VisaTimeLabel[input.visaTime as VisaTimeEnum] || '',
	};
};

export const formatWorkerProgramApplicantList = (
	input: GetWorkerProgramApplicantListResponse['content']
) => {
	return map(input, formatWorkerProgramApplicantDetail);
};

export const formatWorkerProgramFranchiseDetail = (
	input: GetWorkerProgramFranchiseListResponse['content'][number]
) => {
	const type = BUSINESS_TYPE_OPTIONS.find(
		(e: DefaultOptionType) => e.value === input.type
	);
	const typeDetail = [
		...AGRI_FRANCHISE_OPTIONS,
		...FISHERY_FRANCHISE_OPTIONS,
	].find((e: DefaultOptionType) => e.value === input.typeDetail);
	return {
		...input,
		registDt: formatDate(input.registDt),
		typeName: type?.label || '',
		typeDetailName: typeDetail?.label || '',
	};
};

export const formatWorkerProgramFranchiseList = (
	input: GetWorkerProgramFranchiseListResponse['content']
) => {
	return map(input, formatWorkerProgramFranchiseDetail);
};

export const formatWorkerProgramAllListItem = (
	input: GetWorkerProgramListAllResponse[number]
) => {
	return {
		id: input?.id,
		programName: input?.name,
		programStartDate: formatDate(input.startDate),
		programEndDate: formatDate(input.endDate),
	};
};

export const formatWorkerProgramAllList = (
	input: GetWorkerProgramListAllResponse
) => {
	return map(input, formatWorkerProgramAllListItem);
};
